<template>

  <div class="">
    <b-overlay :show="show" spinner-variant="primary" spinner-large rounded="sm" style="height:100vh" variant="dark"
      id="loader">

      <b-container fluid style="padding-top: 100px;text-align:left">
        <b-row>
          <b-col cols="12 headerF">
            <HeaderFixed />
          </b-col>
          <b-col cols="12 headerM">
            <HeaderMobile />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-breadcrumb style=" background-color: #e9ecef78;">
              <b-breadcrumb-item href="#home">
                <router-link to="/">
                  <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                  Home
                </router-link>
              </b-breadcrumb-item>
              <b-breadcrumb-item href="#" active>View Bill</b-breadcrumb-item>
            </b-breadcrumb>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <span class="title">View Bill</span>
          </b-col>
        </b-row>
        <hr />
        <div class="paddingLeft30px">

          <br>
          <b-row>
            <b-col col cols="12" sm="12" md="2" lg="2" style="padding-top: 7px;">
              <span style="font-weight:600">Consumer No <span class="text-danger">*</span></span>
            </b-col>
            <b-col col cols="12" sm="12" md="3" lg="3" style="padding-top: 5px;">
              <b-form-input type="number" maxlength="12" id="consNo" value="" placeholder="Enter your Consumer Number"
                trim required />
            </b-col>
            <!-- <b-col col cols="4" sm="4" md="2" lg="2" style="padding-top: 5px;" >
                <img id="captcha" src="#" alt="captcha">
                <a href="#" @click="generateCaptcha()" ><b-icon icon="arrow-clockwise" font-scale="1.8" style="padding-top:7px"></b-icon></a>
              
          </b-col>
          <b-col col cols="4" sm="4" md="2" lg="2" style="padding-top: 5px;">
              <b-form-input type="number" id="result" placeholder="Enter the Answer" style="padding-top: 7px;" />
          </b-col> -->
            <b-col col cols="4" sm="4" md="3" lg="1" style="padding-top: 5px;">
              <b-button @click="checkConsumerType()" block pill variant="primary" size="md" class="go"
                style="width:100%">
                <b-icon icon="arrow-right-short" animation="" scale="1.8"> </b-icon>
              </b-button>

            </b-col>
          </b-row>

          </br>

          <div id="MobileUpdateDiv" style="display:none">
            <b-row>
              <b-col cols=12>
                <h4 style="color:red"> Unable to send OTP. Mobile Number Not Updated.</h4>
                <a href="MobileUpdate">Click Here to Update Your Mobile Number</a>
              </b-col>
            </b-row>
          </div>
          <div id="BillDiv" class="hideDetails">
            <!-- <b-card header-bg-variant="light" header-text-variant="white" header="Payment Receipt" class="cardStyle">
           -->
            <b-row>
              <b-col cols=12>
                <span class="heading">Bill Details</span>
              </b-col>
            </b-row>

            <b-row class="">
              <b-col col cols="12" sm="12" md="12" lg="12">
                <b-table responsive :items="consumerBill" :fields="consumerBillFields">
                  <template v-slot:cell(due_amt)="data">
                    <span v-html="data.value"></span>
                  </template>
                  <template v-slot:cell(net_amt)="data">
                    <span v-html="data.value"></span>
                  </template>
                  <template v-slot:cell(link)="data">
                    <span v-html="data.value"></span>
                  </template>
                </b-table>
              </b-col>

            </b-row>
            <!-- </b-card> -->
          </div>


        </div>
        <br>
      </b-container>

    </b-overlay>

    <b-modal id="model" centered scrollable title="ALERT !" :static="true" hide-footer>
      <span class="data" id="modalMsg"> </span>
      <br><br>
      <b-button style="width:8rem" variant="outline-info" @click="closeModal()">OK</b-button>
    </b-modal>

    <b-modal id="otpModal" centered no-close-on-esc no-close-on-backdrop title="OTP Verification" hide-footer>
      <b-overlay :show="show1" spinner-variant="primary" spinner-large rounded="sm" style="" variant="dark" id="loader">
        Enter the OTP received in your mobile number <b> {{ consMobile }} </b>
        <b-form-input type="number" id="otp"></b-form-input><br>
        <b-button class="btn" variant="primary" id="success-btn" @click="verifyOtp()">Verify</b-button> &nbsp&nbsp
        <b-button class="btn" variant="outline-primary" id="success-btn" @click="resendOtp()">Resend OTP</b-button>
      </b-overlay>
    </b-modal>
  </div>
</template>


<script>

import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)
var thColor = '#0288d1';
var mobileNo = "";
var consNo = "";


export default {
  name: '',
  components: {

    'HeaderFixed': HeaderFixed,
    'HeaderMobile': HeaderMobile
    //MarqueeText

  },
  computed: {

  },
  data() {
    return {
      consumerNo: '',
      sdCode: '',
      show: false,
      show1: false,
      consMobile: "",
      consumerBillFields: [
        { key: 'bill_no', label: 'Bill Number', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'bill_date', label: 'Bill Date', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'due_date', label: 'Due Date', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'due_amt', label: 'Due Bill Amount', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px', textAlign: 'center' } },
        { key: 'net_amt', label: 'Net Bill Amount', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px', textAlign: 'center' } },
        { key: 'link', label: 'Download', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px', textAlign: 'center' } }
      ],
      consumerBill: []
    }
  },
  methods: {
    checkConsumerType() {
      var consNo = document.getElementById("consNo").value;
      var config = {
        method: 'post',
        url: this.$urlRestapi + '/RestAPI/checkConsumerType',
        headers: {
          'Content-Type': 'text/plain'
        },
        data: consNo
      };
      var parent = this;
      parent.show = true;
      axios(config)
        .then(function (response) {

          parent.show = false;
          console.log(response.data);
          if (response.data == "smartPrePaid") {
            var msgToShow = "This is a Smart Prepaid Consumer.<br><a href='SmartPrepaidBalance' style='text-decoration:underline;font-size:1.4rem'>Click Here</a> to View Smart Prepaid Balance"
            document.getElementById("modalMsg").innerHTML = msgToShow;
            parent.$bvModal.show("model");
            document.getElementById("BillDiv").classList.remove("showDetails");
          }
          else if (response.data == "prePaid") {
            var msgToShow = "This is a Prepaid Consumer.<br> <a href='ReprintVoucher' style='text-decoration:underline;font-size:1.4rem'>Click Here</a> to View Prepaid Voucher"
            document.getElementById("modalMsg").innerHTML = msgToShow;
            parent.$bvModal.show("model");
            document.getElementById("BillDiv").classList.remove("showDetails");
          }
          else {
            parent.sendOtp();
          }

        })
        .catch((e) => {
          console.log("Caught", e.message);
          parent.show = false;
        })

    },
    sendOtp() {
      var parent = this;

      consNo = document.getElementById("consNo").value;

      if ((consNo.toString().length != 12)) {
        this.$bvToast.toast('Enter 12 Digit Consumer Number !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        return;
      }
      parent.show = true;

      axios.post(parent.$urlArms + '/RestAPI/website/otpValidation?consNo=' + consNo)
        .then((response) => {

          console.log(response.data);
          var data = response.data;
          var status = data.msg;

          if (status == "success") {

            if (data.otpGenerated == "Y") {
              parent.$bvToast.toast('OTP Sent Successfully !', {
                title: `Success`,
                variant: 'success',
                solid: true
              });
              parent.$bvModal.show('otpModal');

            }
            else {
              parent.$bvToast.toast('OTP Generation Failed !', {
                title: `Failed`,
                variant: 'danger',
                solid: true
              });
            }
          }
          else {
            parent.show = false;
            parent.$bvModal.show('model');
            document.getElementById("modalMsg").innerHTML = "Sorry, Consumer Not Found";
          }
        })
        .catch((e) => {
          console.log("Caught", e);
          this.show = false;
        })
    },

    resendOtp() {
      var parent = this;
      parent.show1 = true;
      axios.post(this.$urlArms + "/RestAPI/website/resendOTP?consNo=" + consNo).then(function (response) {
        parent.show1 = false;
        if (response.data.msg == "success") {
          parent.$bvToast.toast('OTP Sent Successfully !', {
            title: `Success`,
            variant: 'success',
            solid: true
          });
        }
        else {
          parent.$bvToast.toast('OTP Could not Sent !', {
            title: `danger`,
            variant: 'danger',
            solid: true
          });
        }
      });
    },

    verifyOtp() {
      var parent = this;
      var otp = document.getElementById("otp").value;

      parent.show1 = true;
      axios.post(parent.$urlCommon + "/api/VerifyOtpViewBill?consNo=" + consNo + "&otp=" + otp).then(function (response) {
        parent.show1 = false;
        parent.show = false;
        //console.log(response.data);

        if (response.data.status == "success") {
          parent.$bvToast.toast('OTP Verified Successfully !', {
            title: `Success`,
            variant: 'success',
            solid: true
          });
          parent.$bvModal.hide('otpModal');
          document.getElementById("BillDiv").classList.add("showDetails");
          var temp = [];


          response.data.billData.body.forEach(element => {
            // console.log(element);
            var res1 = element.bill_DATE.split("-");
            var billDateFormatted = res1[2] + "/" + res1[1] + "/" + res1[0];
            var res2 = element.due_DATE.split("-");
            var dueDateFormatted = res2[2] + "/" + res2[1] + "/" + res2[0];
            var dueAmt = "";

            if (element.due_AMOUNT == 0) dueAmt = "Paid";
            else dueAmt = element.due_AMOUNT;

            let subdivision = consNo.substring(0, 3);
            let masked = 'x';
            let shortCode = 'b' + subdivision + masked + element.bill_NO;

            if (response.data.isIRCA) {
              var english = `${window.location.origin}/tu/?s=${shortCode}`

              var obj = {
                "bill_no": element.bill_NO,
                "bill_date": billDateFormatted,
                "due_date": dueDateFormatted,
                "due_amt": "<span style='padding-left:35%'>" + dueAmt + "<span>",
                "net_amt": "<span style='padding-left:35%'>" + element.net_AMOUNT + "<span>",
                "link": `<img src='${parent.$urlCommon}/assets/pdf-icon-3.png' height='32px' width='32px'/><a target='_blank' href='${english}'>Click Here</a>`
              }
            } else {



              var pdflink = `${window.location.origin}/tu/?s=${shortCode}`;
              /* var english = `${window.location.origin}/pdfEngine/v2/energyBill?consNo=${consNo}&billNo=${element.bill_NO}&lang=english`
               var assamese = `${window.location.origin}/pdfEngine/v2/energyBill?consNo=${consNo}&billNo=${element.bill_NO}&lang=assamese`*/



              var obj = {
                "bill_no": element.bill_NO,
                "bill_date": billDateFormatted,
                "due_date": dueDateFormatted,
                "due_amt": "<span style='padding-left:35%'>" + dueAmt + "<span>",
                "net_amt": "<span style='padding-left:35%'>" + element.net_AMOUNT + "<span>",
                "link": `<img src='${parent.$urlCommon}/assets/pdf-icon-3.png' height='32px' width='32px'/><a target='_blank' href='${pdflink}'>Click Here</a>`
              }
            }


            temp.push(obj);
          })
          //console.log(temp);
          parent.consumerBill = temp;
        }
        else if (response.data.status == "exception" || response.data.message == "No data for Consumer No") {

          document.getElementById("modalMsg").innerHTML = "Sorry, Consumer / Bill Not Found";
          parent.$bvModal.show("model");
          document.getElementById("BillDiv").classList.remove("showDetails");

        }
        else {
          parent.$bvToast.toast('OTP not Valid !', {
            title: `danger`,
            variant: 'danger',
            solid: true
          });
          parent.show1 = false;
        }
      });
    },
    closeModal() {
      this.$bvModal.hide('model')
    }
  },
  mounted() {
    // axios.post(this.$urlCommon+"/api/web/getCaptcha").then(function(response) {

    //            document.getElementById("captcha").src= "data:image/png;base64,"+response.data;

    // })
  }
}
//background-image: url('../assets/bg.jpg');background-color: #82828226;

</script>

<style scoped="true">
.blink_me {
  animation: blinker 1s linear infinite;
  font-weight: 600;
}

td {
  padding: 0.3rem;
}

.label {
  font-weight: 600;
}

.data {
  font-weight: 600;
  color: #ff5722;
  font-size: 1.2rem;
}

.hideDetails {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s linear;
  box-shadow: 2px 2px 10px 2px #bdbdbd;
  padding: 1rem;
}

.showDetails {
  visibility: visible;
  opacity: 1;
}

hr {
  margin-top: 5px;
  margin-bottom: 5px;
}

.go:focus {
  box-shadow: none;
}

.paddingRow {
  padding: 0.7rem;
}

.headerF {
  display: block;
}

.headerM {
  display: none;
}

.paddingLeft30px {
  padding-left: 30px;
}

@media (max-width: 768px) {
  .headerF {
    display: none;
  }

  .headerM {
    display: block;
  }

  .paddingLeft30px {
    padding-left: 0px;
  }
}
</style>
